import React from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./providers";
import App from "./components/App";

import '@cloudscape-design/global-styles/index.css';

import "./index.scss";

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <React.Suspense>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.Suspense>
  </React.StrictMode>
);
